<template>
    <ul class="nk-menu">
        <li class="nk-menu-heading">
            <h6 class="overline-title">ACADEMIC WORKSPACE</h6>
        </li>
        <li class="nk-menu-item">
            <router-link
                to="/dashboard"
                class="nk-menu-link"
                :class="{ 'is-active': $route.path === '/home' || $route.path === '/dashboard' || $route.path === '/' }"
            >
                <span class="nk-menu-icon nk-menu-icon--blue"><admin-icon name="grid"></admin-icon></span>
                <menu-item-text menu-key="general.dashboard"></menu-item-text>
            </router-link>
        </li>
        <li v-show="moduleMenu && showMenu('institute_document') && hasPermission('list-institute-document')" class="nk-menu-item">
            <router-link to="/institute/document" exact class="nk-menu-link">
                <span class="nk-menu-icon nk-menu-icon--indigo"><admin-icon name="file"></admin-icon></span>
                <menu-item-text menu-key="institute.document"></menu-item-text>
            </router-link>
        </li>
        <li v-show="moduleMenu && showMenu('reception') && hasAnyPermission(['list-enquiry', 'list-visitor-log', 'list-postal-record', 'list-call-log', 'list-complaint', 'list-gate-pass'])" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-1'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-1')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--cyan"><admin-icon name="inbox"></admin-icon></span>
                <menu-item-text menu-key="reception.reception"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-1'] }" id="collapse-1">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li class="nk-menu-item" v-if="hasPermission('list-enquiry') && showMenu('enquiry')">
                        <router-link to="/reception/enquiry" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="chat"></admin-icon></span>
                            <menu-item-text menu-key="reception.admission_enquiry"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item" v-if="hasPermission('list-visitor-log') && showMenu('visitor_log')">
                        <router-link to="/reception/visitor/log" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="users"></admin-icon></span>
                            <menu-item-text menu-key="reception.visitor_log"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item" v-if="hasPermission('list-call-log') && showMenu('call_log')">
                        <router-link to="/reception/call/log" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="phone"></admin-icon></span>
                            <menu-item-text menu-key="reception.call_log"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item" v-if="hasPermission('list-postal-record') && showMenu('postal_record')">
                        <router-link to="/reception/postal/record" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="mail"></admin-icon></span>
                            <menu-item-text menu-key="reception.postal_record"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item" v-if="hasPermission('list-complaint') && showMenu('complaint')">
                        <router-link to="/reception/complaint" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="alert"></admin-icon></span>
                            <menu-item-text menu-key="reception.complaint"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item" v-if="hasPermission('list-gate-pass') && showMenu('gate_pass')">
                        <router-link to="/reception/gate/pass" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="door-open"></admin-icon></span>
                            <menu-item-text menu-key="reception.gate_pass"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item" v-if="hasPermission('list-visitor-message') && showMenu('visitor_message')">
                        <router-link to="/reception/visitor/message" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="send"></admin-icon></span>
                            <menu-item-text menu-key="reception.visitor_message"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item" v-show="hasPermission('access-configuration')">
                        <a href="#" class="nk-menu-link" :aria-expanded="nestedModuleMenuConfigOpen.ReceptionConfig ? 'true' : 'false'" @click.prevent="toggleNested('ReceptionConfig')" style="cursor: pointer;">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="sliders"></admin-icon></span>
                            <menu-item-text menu-key="reception.reception_configuration"></menu-item-text>
                            <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
                        </a>
                        <div class="nk-menu-collapse" :class="{ 'is-open': nestedModuleMenuConfigOpen.ReceptionConfig }" id="collapse-ReceptionConfig">
                            <ul class="nk-menu-sub sip-menu-sub">
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/reception/enquiry/type" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="tag"></admin-icon></span>
                                        <menu-item-text menu-key="reception.enquiry_type"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/reception/enquiry/source" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="database"></admin-icon></span>
                                        <menu-item-text menu-key="reception.enquiry_source"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/reception/visiting/purpose" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="map-pin"></admin-icon></span>
                                        <menu-item-text menu-key="reception.visiting_purpose"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/reception/calling/purpose" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="phone"></admin-icon></span>
                                        <menu-item-text menu-key="reception.calling_purpose"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/reception/complaint/type" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="alert"></admin-icon></span>
                                        <menu-item-text menu-key="reception.complaint_type"></menu-item-text>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleMenu && showMenu('academic') && hasAnyPermission(['list-academic-session', 'list-course', 'list-batch', 'list-class-teacher', 'list-subject', 'list-subject-teacher', 'list-class-timing', 'list-timetable', 'list-teacher-timetable', 'academic-reports'])" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-2'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-2')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--violet"><admin-icon name="school"></admin-icon></span>
                <menu-item-text menu-key="academic.academic"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-2'] }" id="collapse-2">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li v-if="hasPermission('list-academic-session') && showMenu('academic_session')"
                        class="nk-menu-item">
                        <router-link to="/academic/session" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="calendar"></admin-icon></span>
                            <menu-item-text menu-key="academic.academic_session"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-course') && showMenu('course')" class="nk-menu-item">
                        <router-link to="/academic/course" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="graduation-cap"></admin-icon></span>
                            <menu-item-text menu-key="academic.course"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-batch') && showMenu('batch')" class="nk-menu-item">
                        <router-link to="/academic/batch" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="users"></admin-icon></span>
                            <menu-item-text menu-key="academic.batch"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-class-teacher') && showMenu('class_teacher')" class="nk-menu-item">
                        <router-link to="/academic/class/teacher" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="user-check"></admin-icon></span>
                            <menu-item-text menu-key="academic.class_teacher"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-subject') && showMenu('subject')" class="nk-menu-item">
                        <router-link to="/academic/subject" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="book"></admin-icon></span>
                            <menu-item-text menu-key="academic.subject"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-subject-teacher') && showMenu('subject_teacher')"
                        class="nk-menu-item">
                        <router-link to="/academic/subject/teacher" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="pencil"></admin-icon></span>
                            <menu-item-text menu-key="academic.subject_teacher"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-class-timing') && showMenu('class_timing')" class="nk-menu-item">
                        <router-link to="/academic/class/timing" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="clock"></admin-icon></span>
                            <menu-item-text menu-key="academic.class_timing"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-timetable') && showMenu('timetable')" class="nk-menu-item">
                        <router-link to="/academic/timetable" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="calendar-check"></admin-icon></span>
                            <menu-item-text menu-key="academic.timetable"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-teacher-timetable') && showMenu('teacher_timetable')"
                        class="nk-menu-item">
                        <router-link to="/academic/teacher/timetable" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="clipboard-list"></admin-icon></span>
                            <menu-item-text menu-key="academic.teacher_timetable"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-certificate') && showMenu('certificate')" class="nk-menu-item">
                        <router-link to="/academic/certificate" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="badge"></admin-icon></span>
                            <menu-item-text menu-key="academic.certificate"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('academic-reports') && showMenu('academic_reports')" class="nk-menu-item">
                        <router-link to="/reports/index" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="chart"></admin-icon></span>
                            <menu-item-text menu-key="reports.reports"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-show="hasPermission('access-configuration')" class="nk-menu-item">
                        <a href="#" class="nk-menu-link" :aria-expanded="nestedModuleMenuConfigOpen.academic_config ? 'true' : 'false'" @click.prevent="toggleNested('academic_config')" style="cursor: pointer;">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="sliders"></admin-icon></span>
                            <menu-item-text menu-key="academic.academic_configuration"></menu-item-text>
                            <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
                        </a>
                        <div class="nk-menu-collapse" :class="{ 'is-open': nestedModuleMenuConfigOpen.academic_config }" id="collapse-academic_config">
                            <ul class="nk-menu-sub sip-menu-sub">
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/academic/course/group" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="folder"></admin-icon></span>
                                        <menu-item-text menu-key="academic.course_group"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/academic/institute" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="building"></admin-icon></span>
                                        <menu-item-text menu-key="academic.institute"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/academic/institute" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="building"></admin-icon></span>
                                        <menu-item-text menu-key="academic.institute_other"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/academic/certificate/template" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="file-text"></admin-icon></span>
                                        <menu-item-text menu-key="academic.certificate_template"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/academic/id-card/template" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="id-card"></admin-icon></span>
                                        <menu-item-text menu-key="academic.id_card_template"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/academic/print/template" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="printer"></admin-icon></span>
                                        <menu-item-text menu-key="academic.print_template"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/academic/marksheet/template" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="clipboard-check"></admin-icon></span>
                                        <menu-item-text menu-key="academic.marksheet_template"></menu-item-text>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleMenu && showMenu('student') && hasAnyPermission(['list-registration', 'class-monitor', 'list-student', 'edit-roll-number', 'generate-student-id-card', 'list-student-attendance', 'promote-student', 'terminate-student'])" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-3'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-3')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--emerald"><admin-icon name="graduation-cap"></admin-icon></span>
                <menu-item-text menu-key="student.student"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-3'] }" id="collapse-3">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li v-if="hasPermission('import-student') && showMenu('student_import')" class="nk-menu-item">
                        <router-link to="/student/import" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="upload"></admin-icon></span>
                            <menu-item-text menu-key="student.import"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-registration') && showMenu('registration')" class="nk-menu-item">
                        <router-link to="/student/registration/card-view" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="user-plus"></admin-icon></span>
                            <menu-item-text menu-key="student.registration"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="(hasPermission('list-student') || hasPermission('list-class-teacher-wise-student')) && showMenu('student_list')" class="nk-menu-item">
                        <router-link to="/student/card-view" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="graduation-cap"></admin-icon></span>
                            <menu-item-text menu-key="student.student_list"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('edit-roll-number') && showMenu('roll_number')" class="nk-menu-item">
                        <router-link to="/student/roll/number" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="hash"></admin-icon></span>
                            <menu-item-text menu-key="student.roll_number"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('generate-student-id-card') && showMenu('student_id_card')" class="nk-menu-item">
                        <router-link to="/student/id-card" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="id-card"></admin-icon></span>
                            <menu-item-text menu-key="student.id_card"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('edit-student') && showMenu('student_image_upload')" class="nk-menu-item">
                        <router-link to="/student/image" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="image"></admin-icon></span>
                            <menu-item-text menu-key="student.image_upload"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-student-attendance') && showMenu('student_attendance')" class="nk-menu-item">
                        <router-link to="/student/attendance" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="calendar-check"></admin-icon></span>
                            <menu-item-text menu-key="student.attendance"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('promote-student') && showMenu('promotion')" class="nk-menu-item">
                        <router-link to="/student/promotion" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="trending-up"></admin-icon></span>
                            <menu-item-text menu-key="student.promotion"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('terminate-student') && showMenu('termination')" class="nk-menu-item">
                        <router-link to="/student/termination" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="user-minus"></admin-icon></span>
                            <menu-item-text menu-key="student.termination"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('edit-student') && showMenu('student_parent')" class="nk-menu-item">
                        <router-link to="/student/parent" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="users"></admin-icon></span>
                            <menu-item-text menu-key="student.parent"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('edit-student') && showMenu('student_login')" class="nk-menu-item">
                        <router-link to="/student/login" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="key"></admin-icon></span>
                            <menu-item-text menu-key="student.login"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-student') && showMenu('student_login')" class="nk-menu-item">
                        <router-link to="/student/qr-code" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="qr-code"></admin-icon></span>
                            <menu-item-text menu-key="student.print_qr"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('class-monitor') && showMenu('class_monitor')" class="nk-menu-item">
                        <router-link to="/student/class-monitor" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="eye"></admin-icon></span>
                            <menu-item-text menu-key="student.class_monitor"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('counsellor-report') && showMenu('counsellor_report')" class="nk-menu-item">
                        <router-link to="/student/counsellor-report" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="chart"></admin-icon></span>
                            <menu-item-text menu-key="student.counsellor_report"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-show="hasPermission('access-configuration')" class="nk-menu-item">
                        <a href="#" class="nk-menu-link" :aria-expanded="nestedModuleMenuConfigOpen.student_config ? 'true' : 'false'" @click.prevent="toggleNested('student_config')" style="cursor: pointer;">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="sliders"></admin-icon></span>
                            <menu-item-text menu-key="student.student_configuration"></menu-item-text>
                            <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
                        </a>
                        <div class="nk-menu-collapse" :class="{ 'is-open': nestedModuleMenuConfigOpen.student_config }" id="collapse-student_config">
                            <ul class="nk-menu-sub sip-menu-sub">
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/student" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="sliders"></admin-icon></span>
                                        <menu-item-text menu-key="general.general"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/student/group" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="users"></admin-icon></span>
                                        <menu-item-text menu-key="student.student_group"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/student/document/type" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="file"></admin-icon></span>
                                        <menu-item-text menu-key="student.document_type_only"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/student/house" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="home"></admin-icon></span>
                                        <menu-item-text menu-key="student.house"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/student/question" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="help-circle"></admin-icon></span>
                                        <menu-item-text menu-key="student.student_questions"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/student/favorites" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="heart"></admin-icon></span>
                                        <menu-item-text menu-key="student.favorites"></menu-item-text>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="configMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <router-link to="/configuration/basic" exact class="nk-menu-link">
                <span class="nk-menu-icon nk-menu-icon--blue"><admin-icon name="settings"></admin-icon></span>
                <menu-item-text menu-key="configuration.basic_configuration"></menu-item-text>
            </router-link>
        </li>
        <li v-show="configMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <router-link to="/configuration/social" exact class="nk-menu-link">
                <span class="nk-menu-icon nk-menu-icon--indigo"><admin-icon name="share"></admin-icon></span>
                <menu-item-text menu-key="configuration.social_network"></menu-item-text>
            </router-link>
        </li>
        <li v-show="configMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <router-link to="/configuration/system" exact class="nk-menu-link">
                <span class="nk-menu-icon nk-menu-icon--slate"><admin-icon name="sliders"></admin-icon></span>
                <menu-item-text menu-key="configuration.system_configuration"></menu-item-text>
            </router-link>
        </li>
        <li v-show="configMenu && hasPermission('access-configuration') && getConfig('multilingual')" class="nk-menu-item">
            <router-link to="/configuration/locale" exact class="nk-menu-link">
                <span class="nk-menu-icon nk-menu-icon--teal"><admin-icon name="globe"></admin-icon></span>
                <menu-item-text menu-key="configuration.locale"></menu-item-text>
            </router-link>
        </li>
        <li v-show="configMenu && hasPermission('access-configuration') && hasRole('admin')" class="nk-menu-item">
            <router-link to="/configuration/role" exact class="nk-menu-link">
                <span class="nk-menu-icon nk-menu-icon--violet"><admin-icon name="shield"></admin-icon></span>
                <menu-item-text menu-key="configuration.role"></menu-item-text>
            </router-link>
        </li>
        <li v-show="configMenu && hasPermission('access-configuration') && hasRole('admin')" class="nk-menu-item">
            <router-link to="/configuration/permission" exact class="nk-menu-link">
                <span class="nk-menu-icon nk-menu-icon--purple"><admin-icon name="lock"></admin-icon></span>
                <menu-item-text menu-key="configuration.permission"></menu-item-text>
            </router-link>
        </li>
        <li v-show="configMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <router-link to="/configuration/mail" exact class="nk-menu-link">
                <span class="nk-menu-icon nk-menu-icon--indigo"><admin-icon name="mail"></admin-icon></span>
                <menu-item-text menu-key="configuration.mail_configuration"></menu-item-text>
            </router-link>
        </li>
        <li v-show="configMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <router-link to="/configuration/sms" exact class="nk-menu-link">
                <span class="nk-menu-icon nk-menu-icon--emerald"><admin-icon name="chat"></admin-icon></span>
                <menu-item-text menu-key="configuration.sms_configuration"></menu-item-text>
            </router-link>
        </li>
        <li v-show="configMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <router-link to="/configuration/whatsapp" exact class="nk-menu-link">
                <span class="nk-menu-icon nk-menu-icon--emerald"><admin-icon name="whatsapp"></admin-icon></span>
                <menu-item-text menu-key="configuration.whatsapp_configuration"></menu-item-text>
            </router-link>
        </li>
        <li v-show="configMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <router-link to="/configuration/message_template" exact class="nk-menu-link">
                <span class="nk-menu-icon nk-menu-icon--amber"><admin-icon name="file-text"></admin-icon></span>
                <menu-item-text menu-key="communication.message_template"></menu-item-text>
            </router-link>
        </li>
        <li v-show="configMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <router-link to="/configuration/payment/gateway" exact class="nk-menu-link">
                <span class="nk-menu-icon nk-menu-icon--sky"><admin-icon name="card"></admin-icon></span>
                <menu-item-text menu-key="finance.payment_gateway"></menu-item-text>
            </router-link>
        </li>
        <li v-show="configMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <router-link to="/configuration/authentication" exact class="nk-menu-link">
                <span class="nk-menu-icon nk-menu-icon--rose"><admin-icon name="key"></admin-icon></span>
                <menu-item-text menu-key="auth.authentication"></menu-item-text>
            </router-link>
        </li>
        <li v-show="configMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <router-link to="/configuration/menu" exact class="nk-menu-link">
                <span class="nk-menu-icon nk-menu-icon--cyan"><admin-icon name="menu"></admin-icon></span>
                <menu-item-text menu-key="configuration.menu"></menu-item-text>
            </router-link>
        </li>
        <li v-show="configMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <router-link to="/configuration/module" exact class="nk-menu-link">
                <span class="nk-menu-icon nk-menu-icon--slate"><admin-icon name="layers"></admin-icon></span>
                <menu-item-text menu-key="configuration.module_configuration"></menu-item-text>
            </router-link>
        </li>
        <li v-show="moduleConfigMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-100'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-100')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--cyan"><admin-icon name="sliders"></admin-icon></span>
                <menu-item-text menu-key="reception.reception_configuration"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-100'] }" id="collapse-100">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li class="nk-menu-item">
                        <router-link to="/configuration/reception/enquiry/type" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="tag"></admin-icon></span>
                            <menu-item-text menu-key="reception.enquiry_type"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/reception/enquiry/source" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="database"></admin-icon></span>
                            <menu-item-text menu-key="reception.enquiry_source"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/reception/visiting/purpose" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="map-pin"></admin-icon></span>
                            <menu-item-text menu-key="reception.visiting_purpose"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/reception/calling/purpose" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="phone"></admin-icon></span>
                            <menu-item-text menu-key="reception.calling_purpose"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/reception/complaint/type" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="alert"></admin-icon></span>
                            <menu-item-text menu-key="reception.complaint_type"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleConfigMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-101'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-101')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--violet"><admin-icon name="sliders"></admin-icon></span>
                <menu-item-text menu-key="academic.academic_configuration"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-101'] }" id="collapse-101">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li class="nk-menu-item">
                        <router-link to="/configuration/academic/course/group" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="folder"></admin-icon></span>
                            <menu-item-text menu-key="academic.course_group"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/academic/institute" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="building"></admin-icon></span>
                            <menu-item-text menu-key="academic.institute"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/academic/institute" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="building"></admin-icon></span>
                            <menu-item-text menu-key="academic.institute_other"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/academic/certificate/template" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="file-text"></admin-icon></span>
                            <menu-item-text menu-key="academic.certificate_template"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/academic/id-card/template" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="id-card"></admin-icon></span>
                            <menu-item-text menu-key="academic.id_card_template"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/academic/print/template" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="printer"></admin-icon></span>
                            <menu-item-text menu-key="academic.print_template"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/academic/marksheet/template" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="clipboard-check"></admin-icon></span>
                            <menu-item-text menu-key="academic.marksheet_template"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleConfigMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-102'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-102')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--emerald"><admin-icon name="wallet"></admin-icon></span>
                <menu-item-text menu-key="finance.finance_configuration"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-102'] }" id="collapse-102">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li class="nk-menu-item">
                        <router-link to="/configuration/finance/transaction/category" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="folder"></admin-icon></span>
                            <menu-item-text menu-key="finance.transaction_category"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/finance/payment/method" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="wallet"></admin-icon></span>
                            <menu-item-text menu-key="finance.payment_method"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleConfigMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-103'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-103')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--emerald"><admin-icon name="sliders"></admin-icon></span>
                <menu-item-text menu-key="student.student_configuration"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-103'] }" id="collapse-103">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li class="nk-menu-item">
                        <router-link to="/configuration/student" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="sliders"></admin-icon></span>
                            <menu-item-text menu-key="general.general"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/student/group" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="users"></admin-icon></span>
                            <menu-item-text menu-key="student.student_group"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/student/document/type" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="file"></admin-icon></span>
                            <menu-item-text menu-key="student.document_type_only"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/student/house" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="home"></admin-icon></span>
                            <menu-item-text menu-key="student.house"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/student/question" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="help-circle"></admin-icon></span>
                            <menu-item-text menu-key="student.student_questions"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/student/favorites" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="heart"></admin-icon></span>
                            <menu-item-text menu-key="student.favorites"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleConfigMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-104'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-104')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--pink"><admin-icon name="sliders"></admin-icon></span>
                <menu-item-text menu-key="exam.configuration"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-104'] }" id="collapse-104">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li class="nk-menu-item">
                        <router-link to="/configuration/exam/term" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="calendar"></admin-icon></span>
                            <menu-item-text menu-key="exam.term"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/exam/assessment" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="clipboard-check"></admin-icon></span>
                            <menu-item-text menu-key="exam.assessment"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/exam/observation" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="eye"></admin-icon></span>
                            <menu-item-text menu-key="exam.observation"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/exam/grade" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="star"></admin-icon></span>
                            <menu-item-text menu-key="exam.grade"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/exam/remark-rule" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="chat"></admin-icon></span>
                            <menu-item-text menu-key="exam.remark_rules"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/exam/result-division-rule" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="layers"></admin-icon></span>
                            <menu-item-text menu-key="exam.result_division_rules"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/exam/authority" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="shield"></admin-icon></span>
                            <menu-item-text menu-key="exam.authorities"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/exam/marksheet/template" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="clipboard-check"></admin-icon></span>
                            <menu-item-text menu-key="academic.marksheet_template"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleConfigMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-105'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-105')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--orange"><admin-icon name="briefcase"></admin-icon></span>
                <menu-item-text menu-key="employee.employee_configuration"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-105'] }" id="collapse-105">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li class="nk-menu-item">
                        <router-link to="/configuration/employee" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="briefcase"></admin-icon></span>
                            <menu-item-text menu-key="general.general"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/employee/category" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="tag"></admin-icon></span>
                            <menu-item-text menu-key="employee.category"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/employee/designation" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="badge"></admin-icon></span>
                            <menu-item-text menu-key="employee.designation"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/employee/department" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="building"></admin-icon></span>
                            <menu-item-text menu-key="employee.department"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/employee/group" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="users"></admin-icon></span>
                            <menu-item-text menu-key="employee.employee_group"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/employee/document/type" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="file"></admin-icon></span>
                            <menu-item-text menu-key="employee.document_type_only"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/employee/leave/type" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="calendar"></admin-icon></span>
                            <menu-item-text menu-key="employee.leave_type"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/employee/attendance/type" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="calendar-check"></admin-icon></span>
                            <menu-item-text menu-key="employee.attendance_type"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/employee/pay/head" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="wallet"></admin-icon></span>
                            <menu-item-text menu-key="employee.pay_head"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleConfigMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-106'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-106')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--orange"><admin-icon name="bus"></admin-icon></span>
                <menu-item-text menu-key="transport.transport_configuration"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-106'] }" id="collapse-106">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li class="nk-menu-item">
                        <router-link to="/configuration/transport/vehicle/document/type" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="file"></admin-icon></span>
                            <menu-item-text menu-key="transport.vehicle_document_type_only"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/transport/vehicle/fuel/type" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="drop"></admin-icon></span>
                            <menu-item-text menu-key="transport.vehicle_fuel_type"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/transport/vehicle/service/center" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="wrench"></admin-icon></span>
                            <menu-item-text menu-key="transport.vehicle_service_center_only"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleConfigMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-906'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-906')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--teal"><admin-icon name="bed"></admin-icon></span>
                <menu-item-text menu-key="hostel.hostel_configuration"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-906'] }" id="collapse-906">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li class="nk-menu-item">
                        <router-link to="/configuration/hostel/category" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="tag"></admin-icon></span>
                            <menu-item-text menu-key="hostel.hostel_category"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleConfigMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-107'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-107')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--violet"><admin-icon name="book-open"></admin-icon></span>
                <menu-item-text menu-key="library.library_configuration"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-107'] }" id="collapse-107">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li class="nk-menu-item">
                        <router-link to="/configuration/library" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="book-open"></admin-icon></span>
                            <menu-item-text menu-key="general.general"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/library/book/author" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="pencil"></admin-icon></span>
                            <menu-item-text menu-key="library.book_author"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/library/book/language" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="languages"></admin-icon></span>
                            <menu-item-text menu-key="library.book_language"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/library/book/topic" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="tag"></admin-icon></span>
                            <menu-item-text menu-key="library.book_topic"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/library/book/publisher" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="building"></admin-icon></span>
                            <menu-item-text menu-key="library.book_publisher"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/library/book/condition" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="check-circle"></admin-icon></span>
                            <menu-item-text menu-key="library.book_condition"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleConfigMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-108'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-108')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--rose"><admin-icon name="calendar"></admin-icon></span>
                <menu-item-text menu-key="calendar.calendar_configuration"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-108'] }" id="collapse-108">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li class="nk-menu-item">
                        <router-link to="/configuration/calendar/event/type" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="star"></admin-icon></span>
                            <menu-item-text menu-key="calendar.event_type"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/calendar/celebration-template" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="spark"></admin-icon></span>
                            <menu-item-text menu-key="calendar.celebration_templates"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleConfigMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-109'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-109')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--cyan"><admin-icon name="newspaper"></admin-icon></span>
                <menu-item-text menu-key="post.post_configuration"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-109'] }" id="collapse-109">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li class="nk-menu-item">
                        <router-link to="/configuration/post/article/type" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="newspaper"></admin-icon></span>
                            <menu-item-text menu-key="post.article_type"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleConfigMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-110'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-110')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--sky"><admin-icon name="building"></admin-icon></span>
                <menu-item-text menu-key="asset.asset_configuration"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-110'] }" id="collapse-110">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li class="nk-menu-item">
                        <router-link to="/configuration/asset/building" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="building"></admin-icon></span>
                            <menu-item-text menu-key="asset.building"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/asset/room" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="door-open"></admin-icon></span>
                            <menu-item-text menu-key="asset.room"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleConfigMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <router-link to="/configuration/custom-field" class="nk-menu-link" exact>
                <span class="nk-menu-icon nk-menu-icon--violet"><admin-icon name="sliders"></admin-icon></span>
                <menu-item-text menu-key="configuration.custom_field"></menu-item-text>
            </router-link>
        </li>
        <li v-show="moduleConfigMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-111'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-111')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--teal"><admin-icon name="globe"></admin-icon></span>
                <menu-item-text menu-key="frontend.frontend_configuration"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-111'] }" id="collapse-111">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li class="nk-menu-item">
                        <router-link to="/configuration/frontend/index" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="globe"></admin-icon></span>
                            <menu-item-text menu-key="frontend.frontend"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleConfigMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-112'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-112')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--amber"><admin-icon name="layers"></admin-icon></span>
                <menu-item-text menu-key="misc.misc_configuration"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-112'] }" id="collapse-112">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li class="nk-menu-item">
                        <router-link to="/configuration/misc/religion" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="heart"></admin-icon></span>
                            <menu-item-text menu-key="misc.religion"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/misc/caste" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="users"></admin-icon></span>
                            <menu-item-text menu-key="misc.caste"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/misc/category" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="tag"></admin-icon></span>
                            <menu-item-text menu-key="misc.category"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/misc/blood/group" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="droplets"></admin-icon></span>
                            <menu-item-text menu-key="misc.blood_group"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/misc/disability/type" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="heart"></admin-icon></span>
                            <menu-item-text menu-key="misc.disability_type"></menu-item-text>
                        </router-link>
                    </li>
                    <li class="nk-menu-item">
                        <router-link to="/configuration/misc/medium/instruction" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="languages"></admin-icon></span>
                            <menu-item-text menu-key="misc.medium_instruction"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleMenu && showMenu('employee') && hasAnyPermission(['list-employee', 'generate-employee-id-card'])" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-4'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-4')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--orange"><admin-icon name="briefcase"></admin-icon></span>
                <menu-item-text menu-key="employee.employee"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-4'] }" id="collapse-4">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li v-if="hasPermission('import-employee') && showMenu('employee_import')" class="nk-menu-item">
                        <router-link to="/employee/import" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="upload"></admin-icon></span>
                            <menu-item-text menu-key="employee.import"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="showMenu('employee_list')" class="nk-menu-item">
                        <router-link to="/employee/card-view" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="briefcase"></admin-icon></span>
                            <menu-item-text menu-key="employee.employee_list"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('generate-employee-id-card') && showMenu('employee_id_card')" class="nk-menu-item">
                        <router-link to="/employee/id-card" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="id-card"></admin-icon></span>
                            <menu-item-text menu-key="employee.id_card"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="showMenu('employee_attendance')" class="nk-menu-item">
                        <router-link to="/employee/attendance" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="calendar-check"></admin-icon></span>
                            <menu-item-text menu-key="employee.attendance"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="showMenu('employee_leave')" class="nk-menu-item">
                        <router-link to="/employee/leave" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="calendar"></admin-icon></span>
                            <menu-item-text menu-key="employee.leave"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="showMenu('employee_payroll')" class="nk-menu-item">
                        <router-link to="/employee/payroll" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="wallet"></admin-icon></span>
                            <menu-item-text menu-key="employee.payroll"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-show="hasPermission('access-configuration')" class="nk-menu-item">
                        <a href="#" class="nk-menu-link" :aria-expanded="nestedModuleMenuConfigOpen.employee_config ? 'true' : 'false'" @click.prevent="toggleNested('employee_config')" style="cursor: pointer;">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="briefcase"></admin-icon></span>
                            <menu-item-text menu-key="employee.employee_configuration"></menu-item-text>
                            <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
                        </a>
                        <div class="nk-menu-collapse" :class="{ 'is-open': nestedModuleMenuConfigOpen.employee_config }" id="collapse-employee_config">
                            <ul class="nk-menu-sub sip-menu-sub">
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/employee" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="briefcase"></admin-icon></span>
                                        <menu-item-text menu-key="general.general"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/employee/category" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="tag"></admin-icon></span>
                                        <menu-item-text menu-key="employee.category"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/employee/designation" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="badge"></admin-icon></span>
                                        <menu-item-text menu-key="employee.designation"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/employee/department" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="building"></admin-icon></span>
                                        <menu-item-text menu-key="employee.department"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/employee/group" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="users"></admin-icon></span>
                                        <menu-item-text menu-key="employee.employee_group"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/employee/document/type" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="file"></admin-icon></span>
                                        <menu-item-text menu-key="employee.document_type_only"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/employee/leave/type" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="calendar"></admin-icon></span>
                                        <menu-item-text menu-key="employee.leave_type"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/employee/attendance/type" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="calendar-check"></admin-icon></span>
                                        <menu-item-text menu-key="employee.attendance_type"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/employee/pay/head" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="wallet"></admin-icon></span>
                                        <menu-item-text menu-key="employee.pay_head"></menu-item-text>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleMenu && showMenu('class_and_meet') && hasAnyPermission(['list-live_classes', 'list-live_meeting', 'live_class_report', 'live_meeting_report'])" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-zoom'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-zoom')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--rose"><admin-icon name="video"></admin-icon></span>
                <menu-item-text menu-key="meet.class_and_meet"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-zoom'] }" id="collapse-zoom">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li v-if="hasPermission('list-live_classes') && showMenu('live_classes')" class="nk-menu-item">
                        <router-link to="/meet/live-class" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="video"></admin-icon></span>
                            <menu-item-text menu-key="meet.live_classes"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-live_meeting') && showMenu('live_meeting')" class="nk-menu-item">
                        <router-link to="/meet/live-meeting" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="video"></admin-icon></span>
                            <menu-item-text menu-key="meet.live_meeting"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('live_class_report') && showMenu('live_class_report')" class="nk-menu-item">
                        <router-link to="/meet/live-class/report" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="chart"></admin-icon></span>
                            <menu-item-text menu-key="meet.live_class_report"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('live_meeting_report') && showMenu('live_meeting_report')" class="nk-menu-item">
                        <router-link to="/meet/live-meeting/report" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="chart"></admin-icon></span>
                            <menu-item-text menu-key="meet.live_meeting_report"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>

        <li v-show="moduleMenu && showMenu('lesson_plan') && hasAnyPermission(['manage-lesson-plan', 'manage-syllabus-status', 'lessons', 'syllabus-topic', 'subject-lesson-plan-report', 'syllabus-status-report'])" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-lessons'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-lessons')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--indigo"><admin-icon name="book-open"></admin-icon></span>
                <menu-item-text menu-key="resource.lesson_plan"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-lessons'] }" id="collapse-lessons">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li v-if="hasPermission('manage-lesson-plan') && showMenu('manage_lesson_plan')" class="nk-menu-item">
                        <router-link to="/lesson-plan/manage-lesson-plan" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="clipboard-list"></admin-icon></span>
                            <menu-item-text menu-key="resource.manage_lesson_plan"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('manage-syllabus-status') && showMenu('manage_syllabus_status')" class="nk-menu-item">
                        <router-link to="/lesson-plan/syllabus-status" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="check-circle"></admin-icon></span>
                            <menu-item-text menu-key="resource.manage_syllabus_status"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('lessons') && showMenu('lessons')" class="nk-menu-item">
                        <router-link to="/lesson-plan/lessons" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="book"></admin-icon></span>
                            <menu-item-text menu-key="resource.lessons"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('syllabus-topic') && showMenu('syllabus_topic')" class="nk-menu-item">
                        <router-link to="/lesson-plan/topics" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="tag"></admin-icon></span>
                            <menu-item-text menu-key="resource.syllabus_topic"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('subject-lesson-plan-report') && showMenu('subject_lesson_plan_report')" class="nk-menu-item">
                        <router-link to="/lesson-plan/reports/subject-wise" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="chart"></admin-icon></span>
                            <menu-item-text menu-key="resource.subject_lesson_plan_report"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('syllabus-status-report') && showMenu('syllabus_status_report')" class="nk-menu-item">
                        <router-link to="/lesson-plan/reports/status-report" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="clipboard-check"></admin-icon></span>
                            <menu-item-text menu-key="resource.syllabus_status_report"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>

        <li v-show="moduleMenu && showMenu('behaviour_records') && hasAnyPermission(['list-assign-incidents', 'list-incidents', 'incidents-report'])" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-incidents'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-incidents')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--amber"><admin-icon name="alert"></admin-icon></span>
                <menu-item-text menu-key="incident.behaviour_records"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-incidents'] }" id="collapse-incidents">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li v-if="hasPermission('list-assign-incidents') && showMenu('assign_incidents')" class="nk-menu-item">
                        <router-link to="/behaviour/assign" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="user-plus"></admin-icon></span>
                            <menu-item-text menu-key="incident.assign_incidents"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-incidents') && showMenu('incidents')" class="nk-menu-item">
                        <router-link to="/behaviour/incidents" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="alert"></admin-icon></span>
                            <menu-item-text menu-key="incident.incidents"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('incidents-report') && showMenu('incidents_report')" class="nk-menu-item">
                        <router-link to="/behaviour/reports" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="chart"></admin-icon></span>
                            <menu-item-text menu-key="general.report"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>

        <li v-show="moduleMenu && showMenu('download_center') && hasAnyPermission(['list-content-type', 'list-content-share-list', 'iupload-content', 'video-tutorial'])" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-download-center'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-download-center')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--blue"><admin-icon name="download"></admin-icon></span>
                <menu-item-text menu-key="download_center.download_center"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-download-center'] }" id="collapse-download-center">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li v-if="hasPermission('list-content-type') && showMenu('content_type')" class="nk-menu-item">
                        <router-link to="/download-center/content-type" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="folder"></admin-icon></span>
                            <menu-item-text menu-key="download_center.content_type"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-content-share-list') && showMenu('content_share_list')" class="nk-menu-item">
                        <router-link to="/download-center/document-share-list" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="share"></admin-icon></span>
                            <menu-item-text menu-key="download_center.content_share_list"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('upload-content') && showMenu('upload_content')" class="nk-menu-item">
                        <router-link to="/download-center/content-list" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="upload"></admin-icon></span>
                            <menu-item-text menu-key="download_center.upload_content"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('video-tutorial') && showMenu('video_tutorial')" class="nk-menu-item">
                        <router-link to="/download-center/video-tutorial" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="video"></admin-icon></span>
                            <menu-item-text menu-key="download_center.video_tutorial"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>

        <li v-show="moduleMenu && showMenu('qr_attendance') && hasAnyPermission(['qr-take-attendance', 'qr-attendance-report'])" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-qr'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-qr')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--purple"><admin-icon name="qr-code"></admin-icon></span>
                <menu-item-text menu-key="student.qr_attendance"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-qr'] }" id="collapse-qr">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li v-if="hasPermission('qr-take-attendance') && showMenu('qr_student_attendance')" class="nk-menu-item">
                        <router-link to="/qr/attendance" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="scan"></admin-icon></span>
                            <menu-item-text menu-key="student.attendance"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('qr-attendance-report') && showMenu('qr_attendance_report')" class="nk-menu-item">
                        <router-link to="/qr/attendance-report" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="chart"></admin-icon></span>
                            <menu-item-text menu-key="student.attendance_report"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleMenu && showMenu('exam') && hasAnyPermission(['list-exam-schedule', 'list-exam-mark', 'access-exam-report', 'access-class-teacher-wise-exam-report', 'list-online-exam'])" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-5'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-5')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--pink"><admin-icon name="clipboard-check"></admin-icon></span>
                <menu-item-text menu-key="exam.exam"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-5'] }" id="collapse-5">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li v-if="hasPermission('list-exam-schedule') && showMenu('exam_schedule')" class="nk-menu-item">
                        <router-link to="/exam/schedule" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="calendar"></admin-icon></span>
                            <menu-item-text menu-key="exam.schedule"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-exam-mark') && showMenu('exam_record_mark')" class="nk-menu-item">
                        <router-link to="/exam/record" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="clipboard-list"></admin-icon></span>
                            <menu-item-text menu-key="exam.record"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasAnyPermission(['access-exam-report', 'access-class-teacher-wise-exam-report']) && showMenu('exam_report_card')" class="nk-menu-item">
                        <router-link to="/exam/report-card-attendance" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="calendar-check"></admin-icon></span>
                            <menu-item-text menu-key="exam.report_card_attendance"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasAnyPermission(['access-exam-report', 'access-class-teacher-wise-exam-report']) && showMenu('exam_report_card')" class="nk-menu-item">
                        <router-link to="/exam/report" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="file-text"></admin-icon></span>
                            <menu-item-text menu-key="exam.report"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasAnyPermission(['access-exam-report', 'access-class-teacher-wise-exam-report']) && showMenu('exam_report_card')" class="nk-menu-item">
                        <router-link to="/exam/result-announcement" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="megaphone"></admin-icon></span>
                            <menu-item-text menu-key="exam.result_announcement"></menu-item-text>
                        </router-link>
                    </li>
                    <template v-if="hasNotAnyRole(['student', 'parent']) && showMenu('exam_topper_report')">
                        <li v-if="hasAnyPermission(['access-exam-report', 'access-class-teacher-wise-exam-report'])" class="nk-menu-item">
                            <router-link to="/exam/report/topper" class="nk-menu-link">
                                <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="trophy"></admin-icon></span>
                                <menu-item-text menu-key="exam.topper_report"></menu-item-text>
                            </router-link>
                        </li>
                    </template>
                    <li v-if="hasAnyPermission(['access-exam-report', 'access-class-teacher-wise-exam-report']) && showMenu('exam_report_analysis')" class="nk-menu-item">
                        <a href="#" class="nk-menu-link" :aria-expanded="nestedModuleMenuConfigOpen.examReportAnalysis ? 'true' : 'false'" @click.prevent="toggleNested('examReportAnalysis')" style="cursor: pointer;">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="chart"></admin-icon></span>
                            <menu-item-text menu-key="exam.report_analysis"></menu-item-text>
                            <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
                        </a>
                        <div class="nk-menu-collapse" :class="{ 'is-open': nestedModuleMenuConfigOpen.examReportAnalysis }" id="collapse-exam-report-analysis">
                            <ul class="nk-menu-sub sip-menu-sub">
                                <li class="nk-menu-item">
                                    <router-link to="/exam/report/analysis" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="chart"></admin-icon></span>
                                        <menu-item-text menu-key="exam.report_analysis"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link :to="{ path: '/exam/report/analysis/export', query: { type: 'course-group-wise' } }" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="folder"></admin-icon></span>
                                        <menu-item-text menu-key="exam.course_group_wise_report" label="Course Group wise Report"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link :to="{ path: '/exam/report/analysis/export', query: { type: 'batch-wise' } }" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="users"></admin-icon></span>
                                        <menu-item-text menu-key="exam.batch_wise_report" label="Batch wise Report"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link :to="{ path: '/exam/report/analysis/export', query: { type: 'exam-wise' } }" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="chart"></admin-icon></span>
                                        <menu-item-text menu-key="exam.exam_wise_report"></menu-item-text>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li v-if="hasPermission('list-online-exam') && showMenu('online_exam')" class="nk-menu-item">
                        <router-link to="/online-exam" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="monitor"></admin-icon></span>
                            <menu-item-text menu-key="exam.online_exam"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-show="hasPermission('access-configuration')" class="nk-menu-item">
                        <a href="#" class="nk-menu-link" :aria-expanded="nestedModuleMenuConfigOpen.exam_config ? 'true' : 'false'" @click.prevent="toggleNested('exam_config')" style="cursor: pointer;">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="sliders"></admin-icon></span>
                            <menu-item-text menu-key="exam.configuration"></menu-item-text>
                            <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
                        </a>
                        <div class="nk-menu-collapse" :class="{ 'is-open': nestedModuleMenuConfigOpen.exam_config }" id="collapse-exam_config">
                            <ul class="nk-menu-sub sip-menu-sub">
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/exam/term" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="calendar"></admin-icon></span>
                                        <menu-item-text menu-key="exam.term"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/exam/assessment" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="clipboard-check"></admin-icon></span>
                                        <menu-item-text menu-key="exam.assessment"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/exam/observation" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="eye"></admin-icon></span>
                                        <menu-item-text menu-key="exam.observation"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/exam/grade" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="star"></admin-icon></span>
                                        <menu-item-text menu-key="exam.grade"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/exam/remark-rule" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="chat"></admin-icon></span>
                                        <menu-item-text menu-key="exam.remark_rules"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/exam/result-division-rule" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="layers"></admin-icon></span>
                                        <menu-item-text menu-key="exam.result_division_rules"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/exam/authority" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="shield"></admin-icon></span>
                                        <menu-item-text menu-key="exam.authorities"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/exam/marksheet/template" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="clipboard-check"></admin-icon></span>
                                        <menu-item-text menu-key="academic.marksheet_template"></menu-item-text>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </li>
        <li class="nk-menu-heading">
            <h6 class="overline-title">FINANCE & BILLING</h6>
        </li>
        <li v-show="moduleMenu && showMenu('finance') && hasAnyPermission(['list-fee-group', 'list-fee-head', 'list-fee-allocation', 'list-fee-concession', 'list-account', 'list-income', 'list-expense', 'list-account-transfer'])" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-6'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-6')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--emerald"><admin-icon name="rupee"></admin-icon></span>
                <menu-item-text menu-key="finance.finance"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-6'] }" id="collapse-6">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li v-if="hasPermission('list-fee-group') && showMenu('fee_group')" class="nk-menu-item">
                        <router-link to="/finance/fee/group" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="folder"></admin-icon></span>
                            <menu-item-text menu-key="finance.fee_group"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-fee-head') && showMenu('fee_head')" class="nk-menu-item">
                        <router-link to="/finance/fee/head" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="tag"></admin-icon></span>
                            <menu-item-text menu-key="finance.fee_head"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-fee-concession') && showMenu('fee_concession')" class="nk-menu-item">
                        <router-link to="/finance/fee/concession" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="percent"></admin-icon></span>
                            <menu-item-text menu-key="finance.fee_concession"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-fee-allocation') && showMenu('fee_allocation')" class="nk-menu-item">
                        <router-link to="/finance/fee/allocation" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="layers"></admin-icon></span>
                            <menu-item-text menu-key="finance.fee_allocation"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-account') && showMenu('account')" class="nk-menu-item">
                        <router-link to="/finance/account" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="wallet"></admin-icon></span>
                            <menu-item-text menu-key="finance.account"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-income') && showMenu('income')" class="nk-menu-item">
                        <router-link to="/finance/transaction/income" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="trending-up"></admin-icon></span>
                            <menu-item-text menu-key="finance.income"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-expense') && showMenu('expense')" class="nk-menu-item">
                        <router-link to="/finance/transaction/expense" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="receipt"></admin-icon></span>
                            <menu-item-text menu-key="finance.expense"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-account-transfer') && showMenu('account_transfer')" class="nk-menu-item">
                        <router-link to="/finance/transaction/account/transfer" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="refresh"></admin-icon></span>
                            <menu-item-text menu-key="finance.account_transfer"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="showMenu('finance_report')" class="nk-menu-item">
                        <router-link to="/finance/report" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="chart"></admin-icon></span>
                            <menu-item-text menu-key="general.report"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-show="hasPermission('access-configuration')" class="nk-menu-item">
                        <a href="#" class="nk-menu-link" :aria-expanded="nestedModuleMenuConfigOpen.finance_cofig ? 'true' : 'false'" @click.prevent="toggleNested('finance_cofig')" style="cursor: pointer;">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="wallet"></admin-icon></span>
                            <menu-item-text menu-key="finance.finance_configuration"></menu-item-text>
                            <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
                        </a>
                        <div class="nk-menu-collapse" :class="{ 'is-open': nestedModuleMenuConfigOpen.finance_cofig }" id="collapse-finance_cofig">
                            <ul class="nk-menu-sub sip-menu-sub">
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/finance/transaction/category" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="folder"></admin-icon></span>
                                        <menu-item-text menu-key="finance.transaction_category"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/finance/payment/method" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="wallet"></admin-icon></span>
                                        <menu-item-text menu-key="finance.payment_method"></menu-item-text>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleMenu && showMenu('transport') && hasAnyPermission(['list-transport-circle', 'list-transport-stoppage', 'list-transport-fee', 'list-vehicle', 'list-vehicle-incharge', 'list-vehicle-document', 'list-vehicle-log', 'list-vehicle-service-record', 'list-vehicle-fuel'])" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-26'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-26')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--orange"><admin-icon name="bus"></admin-icon></span>
                <menu-item-text menu-key="transport.transport"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-26'] }" id="collapse-26">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li v-if="hasPermission('list-transport-stoppage') && showMenu('vehicle')" class="nk-menu-item">
                        <router-link to="/transport/stoppage" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="map-pin"></admin-icon></span>
                            <menu-item-text menu-key="transport.transport_stoppage"></menu-item-text>
                        </router-link>
                    </li>
                    
                    <li v-if="hasPermission('list-transport-circle') && showMenu('vehicle')" class="nk-menu-item">
                        <router-link to="/transport/circle" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="route"></admin-icon></span>
                            <menu-item-text menu-key="transport.transport_circle"></menu-item-text>
                        </router-link>
                    </li>

                    <li v-if="showMenu('transport_route')" class="nk-menu-item">
                        <router-link to="/transport/route" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="route"></admin-icon></span>
                            <menu-item-text menu-key="transport.route"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-vehicle') && showMenu('vehicle')" class="nk-menu-item">
                        <router-link to="/transport/vehicle" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="bus"></admin-icon></span>
                            <menu-item-text menu-key="transport.vehicle"></menu-item-text>
                        </router-link>
                    </li>

                    <li v-if="hasPermission('list-transport-fee') && showMenu('transport_fee')" class="nk-menu-item">
                        <router-link to="/transport/fee" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="rupee"></admin-icon></span>
                            <menu-item-text menu-key="transport.fee"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-vehicle-incharge') && showMenu('vehicle_incharge')" class="nk-menu-item">
                        <router-link to="/transport/vehicle/incharge" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="user"></admin-icon></span>
                            <menu-item-text menu-key="transport.vehicle_incharge"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-vehicle-document') && showMenu('vehicle_document')" class="nk-menu-item">
                        <router-link to="/transport/vehicle/document" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="file"></admin-icon></span>
                            <menu-item-text menu-key="transport.document"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-vehicle-fuel') && showMenu('vehicle_fuel')" class="nk-menu-item">
                        <router-link to="/transport/vehicle/fuel" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="drop"></admin-icon></span>
                            <menu-item-text menu-key="transport.fuel"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-vehicle-log') && showMenu('vehicle_log')" class="nk-menu-item">
                        <router-link to="/transport/vehicle/log" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="clipboard"></admin-icon></span>
                            <menu-item-text menu-key="transport.log"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-vehicle-service-record') && showMenu('vehicle_service_record')" class="nk-menu-item">
                        <router-link to="/transport/vehicle/service/record" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="wrench"></admin-icon></span>
                            <menu-item-text menu-key="transport.service_record"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('access-transport-report') && showMenu('transport_report')" class="nk-menu-item">
                        <router-link to="/transport/report" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="chart"></admin-icon></span>
                            <menu-item-text menu-key="general.report"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-show="hasPermission('access-configuration')" class="nk-menu-item">
                        <a href="#" class="nk-menu-link" :aria-expanded="nestedModuleMenuConfigOpen.transport_config ? 'true' : 'false'" @click.prevent="toggleNested('transport_config')" style="cursor: pointer;">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="bus"></admin-icon></span>
                            <menu-item-text menu-key="transport.transport_configuration"></menu-item-text>
                            <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
                        </a>
                        <div class="nk-menu-collapse" :class="{ 'is-open': nestedModuleMenuConfigOpen.transport_config }" id="collapse-transport_config">
                            <ul class="nk-menu-sub sip-menu-sub">
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/transport/vehicle/document/type" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="file"></admin-icon></span>
                                        <menu-item-text menu-key="transport.vehicle_document_type_only"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/transport/vehicle/fuel/type" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="drop"></admin-icon></span>
                                        <menu-item-text menu-key="transport.vehicle_fuel_type"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/transport/vehicle/service/center" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="wrench"></admin-icon></span>
                                        <menu-item-text menu-key="transport.vehicle_service_center_only"></menu-item-text>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleMenu && showMenu('hostel') && hasAnyPermission(['hostel', 'list-facilities', 'list-rooms', 'list-meal-schedule', 'list-meal-plan', 'access-hostel-report'])" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-56'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-56')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--teal"><admin-icon name="bed"></admin-icon></span>
                <menu-item-text menu-key="hostel.hostel"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-56'] }" id="collapse-56">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li v-if="showMenu('hostel')" class="nk-menu-item">
                        <router-link to="/hostel/hostel" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="bed"></admin-icon></span>
                            <menu-item-text menu-key="hostel.hostel"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-facilities') && showMenu('facilities')" class="nk-menu-item">
                        <router-link to="/hostel/facilities" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="spark"></admin-icon></span>
                            <menu-item-text menu-key="hostel.facilities"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-rooms') && showMenu('rooms')" class="nk-menu-item">
                        <router-link to="/hostel/rooms" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="door-open"></admin-icon></span>
                            <menu-item-text menu-key="hostel.rooms"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-rooms') && showMenu('incharge')" class="nk-menu-item">
                        <router-link to="/hostel/incharge" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="user"></admin-icon></span>
                            <menu-item-text menu-key="hostel.hostel_incharge"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-meal-schedule') && showMenu('meal_schedule')" class="nk-menu-item">
                        <router-link to="/hostel/meal-schedule" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="calendar"></admin-icon></span>
                            <menu-item-text menu-key="hostel.meal_schedule"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-meal-schedule') && showMenu('food_menu')" class="nk-menu-item">
                        <router-link to="/hostel/food-menu" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="utensils"></admin-icon></span>
                            <menu-item-text menu-key="hostel.food_menu"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-meal-plan') && showMenu('meal_plan')" class="nk-menu-item">
                        <router-link to="/hostel/meal-plan" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="food"></admin-icon></span>
                            <menu-item-text menu-key="hostel.meal_plan"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-meal-plan') && showMenu('meal_plan')" class="nk-menu-item">
                        <router-link to="/hostel/report" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="chart"></admin-icon></span>
                            <menu-item-text menu-key="general.report"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-show="hasPermission('access-configuration')" class="nk-menu-item">
                        <a href="#" class="nk-menu-link" :aria-expanded="nestedModuleMenuConfigOpen.hostel_config ? 'true' : 'false'" @click.prevent="toggleNested('hostel_config')" style="cursor: pointer;">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="bed"></admin-icon></span>
                            <menu-item-text menu-key="hostel.hostel_configuration"></menu-item-text>
                            <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
                        </a>
                        <div class="nk-menu-collapse" :class="{ 'is-open': nestedModuleMenuConfigOpen.hostel_config }" id="collapse-hostel_config">
                            <ul class="nk-menu-sub sip-menu-sub">
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/hostel/category" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="tag"></admin-icon></span>
                                        <menu-item-text menu-key="hostel.hostel_category"></menu-item-text>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </li>

        <li class="nk-menu-heading">
            <h6 class="overline-title">LOGISTICS & RESOURCES</h6>
        </li>
        <li v-show="moduleMenu && showMenu('calendar') && hasAnyPermission(['list-holiday', 'list-event'])" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-7'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-7')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--rose"><admin-icon name="calendar"></admin-icon></span>
                <menu-item-text menu-key="calendar.calendar"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-7'] }" id="collapse-7">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li v-if="hasPermission('list-holiday') && showMenu('holiday')" class="nk-menu-item">
                        <router-link to="/calendar/holiday" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="sun"></admin-icon></span>
                            <menu-item-text menu-key="calendar.holiday"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-event') && showMenu('event')" class="nk-menu-item">
                        <router-link to="/calendar/event" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="star"></admin-icon></span>
                            <menu-item-text menu-key="calendar.event"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasAnyPermission(['list-birthday', 'list-anniversary', 'list-work-anniversary']) && showMenu('celebration')" class="nk-menu-item">
                        <router-link to="/calendar/celebration/birthday" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="spark"></admin-icon></span>
                            <menu-item-text menu-key="calendar.celebration"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleMenu && showMenu('resource') && hasAnyPermission(['list-assignment', 'list-home-work', 'list-notes', 'list-lesson-plan', 'list-syllabus'])" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-8'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-8')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--amber"><admin-icon name="folder-open"></admin-icon></span>
                <menu-item-text menu-key="resource.resource"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-8'] }" id="collapse-8">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li v-if="hasPermission('list-assignment') && showMenu('assignment')" class="nk-menu-item">
                        <router-link to="/resource/assignment" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="clipboard-list"></admin-icon></span>
                            <menu-item-text menu-key="resource.assignment"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-home-work') && showMenu('home_work')" class="nk-menu-item">
                        <router-link to="/resource/home-work" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="pencil"></admin-icon></span>
                            <menu-item-text menu-key="resource.home_work"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-notes') && showMenu('notes')" class="nk-menu-item">
                        <router-link to="/resource/notes" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="file-text"></admin-icon></span>
                            <menu-item-text menu-key="resource.notes"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-lesson-plan') && showMenu('lesson_plan')" class="nk-menu-item">
                        <router-link to="/resource/lesson/plan" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="book-open"></admin-icon></span>
                            <menu-item-text menu-key="resource.curriculum_plan"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-syllabus') && showMenu('syllabus')" class="nk-menu-item">
                        <router-link to="/resource/syllabus" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="list"></admin-icon></span>
                            <menu-item-text menu-key="resource.syllabus"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleMenu && showMenu('library') && hasAnyPermission(['list-book', 'issue-book', 'return-book'])" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-9'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-9')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--violet"><admin-icon name="book-open"></admin-icon></span>
                <menu-item-text menu-key="library.library"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-9'] }" id="collapse-9">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li v-if="hasPermission('list-book') && showMenu('book')" class="nk-menu-item">
                        <router-link to="/library/book" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="book"></admin-icon></span>
                            <menu-item-text menu-key="library.book"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('issue-book') && showMenu('issue_book')" class="nk-menu-item">
                        <router-link to="/library/issue" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="upload"></admin-icon></span>
                            <menu-item-text menu-key="library.issue"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('return-book') && showMenu('return_book')" class="nk-menu-item">
                        <router-link to="/library/return" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="return"></admin-icon></span>
                            <menu-item-text menu-key="library.return"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-show="hasPermission('access-configuration')" class="nk-menu-item">
                        <a href="#" class="nk-menu-link" :aria-expanded="nestedModuleMenuConfigOpen.library_config ? 'true' : 'false'" @click.prevent="toggleNested('library_config')" style="cursor: pointer;">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="book-open"></admin-icon></span>
                            <menu-item-text menu-key="library.library_configuration"></menu-item-text>
                            <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
                        </a>
                        <div class="nk-menu-collapse" :class="{ 'is-open': nestedModuleMenuConfigOpen.library_config }" id="collapse-library_config">
                            <ul class="nk-menu-sub sip-menu-sub">
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/library" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="book-open"></admin-icon></span>
                                        <menu-item-text menu-key="general.general"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/library/book/author" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="pencil"></admin-icon></span>
                                        <menu-item-text menu-key="library.book_author"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/library/book/language" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="languages"></admin-icon></span>
                                        <menu-item-text menu-key="library.book_language"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/library/book/topic" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="tag"></admin-icon></span>
                                        <menu-item-text menu-key="library.book_topic"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/library/book/publisher" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="building"></admin-icon></span>
                                        <menu-item-text menu-key="library.book_publisher"></menu-item-text>
                                    </router-link>
                                </li>
                                <li class="nk-menu-item">
                                    <router-link to="/configuration/library/book/condition" class="nk-menu-link">
                                        <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="check-circle"></admin-icon></span>
                                        <menu-item-text menu-key="library.book_condition"></menu-item-text>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleMenu && showMenu('inventory') && hasAnyPermission(['list-stock-category', 'list-stock-item', 'list-vendor', 'list-stock-purchase', 'list-stock-transfer'])" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-10'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-10')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--sky"><admin-icon name="box"></admin-icon></span>
                <menu-item-text menu-key="inventory.inventory"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-10'] }" id="collapse-10">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li v-if="hasPermission('list-stock-category') && showMenu('stock_category')" class="nk-menu-item">
                        <router-link to="/inventory/stock/category" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="folder"></admin-icon></span>
                            <menu-item-text menu-key="inventory.stock_category"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-stock-item') && showMenu('stock_item')" class="nk-menu-item">
                        <router-link to="/inventory/stock/item" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="box"></admin-icon></span>
                            <menu-item-text menu-key="inventory.stock_item"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-vendor') && showMenu('vendor')" class="nk-menu-item">
                        <router-link to="/inventory/vendor" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="truck"></admin-icon></span>
                            <menu-item-text menu-key="inventory.vendor"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-stock-purchase') && showMenu('stock_purchase')" class="nk-menu-item">
                        <router-link to="/inventory/stock/purchase" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="cart"></admin-icon></span>
                            <menu-item-text menu-key="inventory.stock_purchase"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-stock-transfer') && showMenu('stock_transfer')" class="nk-menu-item">
                        <router-link to="/inventory/stock/transfer" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="refresh"></admin-icon></span>
                            <menu-item-text menu-key="inventory.stock_transfer"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>
        <li class="nk-menu-heading">
            <h6 class="overline-title">COMMUNICATION & OPS</h6>
        </li>
        <li v-show="moduleMenu && showMenu('post') && hasPermission('list-article')" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-11'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-11')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--cyan"><admin-icon name="newspaper"></admin-icon></span>
                <menu-item-text menu-key="post.post"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-11'] }" id="collapse-11">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li v-if="showMenu('post_feed')" class="nk-menu-item">
                        <router-link to="/post/feed" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="activity"></admin-icon></span>
                            <menu-item-text menu-key="post.feed"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="showMenu('article')" class="nk-menu-item">
                        <router-link to="/post/article" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="newspaper"></admin-icon></span>
                            <menu-item-text menu-key="post.article"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleMenu && showMenu('communication') && hasAnyPermission(['send-sms', 'send-email', 'send-push-notification', 'list-meeting'])" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-12'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-12')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--purple"><admin-icon name="megaphone"></admin-icon></span>
                <menu-item-text menu-key="communication.communication"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-12'] }" id="collapse-12">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li v-if="hasPermission('send-sms') && showMenu('send_sms')" class="nk-menu-item">
                        <router-link to="/communication/balance" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="wallet"></admin-icon></span>
                            <menu-item-text menu-key="communication.balance"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="showMenu('communication_history') && hasAnyPermission(['send-sms', 'send-email', 'send-push-notification'])" class="nk-menu-item">
                        <router-link to="/communication" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="clock"></admin-icon></span>
                            <menu-item-text menu-key="communication.history"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="showMenu('my_notification')" class="nk-menu-item">
                        <router-link to="/communication/notification" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="bell"></admin-icon></span>
                            <menu-item-text menu-key="communication.my_notification"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('send-sms') && showMenu('send_sms')" class="nk-menu-item">
                        <router-link to="/communication/sms" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="chat"></admin-icon></span>
                            <menu-item-text menu-key="communication.sms"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('send-sms') && showMenu('send_sms')" class="nk-menu-item">
                        <router-link to="/communication/whatsapp" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="whatsapp"></admin-icon></span>
                            <menu-item-text menu-key="communication.whatsapp"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('send-email') && showMenu('send_email')" class="nk-menu-item">
                        <router-link to="/communication/email" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="mail"></admin-icon></span>
                            <menu-item-text menu-key="communication.email"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('send-push-notification') && showMenu('send_push_notification')" class="nk-menu-item">
                        <router-link to="/communication/push-notification" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="bell"></admin-icon></span>
                            <menu-item-text menu-key="communication.push_notification"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-meeting') && showMenu('meeting')" class="nk-menu-item">
                        <router-link to="/communication/meeting" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="video"></admin-icon></span>
                            <menu-item-text menu-key="communication.meeting"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="hasPermission('list-meeting') && showMenu('my_meeting')" class="nk-menu-item">
                        <router-link to="/communication/my-meeting" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="video"></admin-icon></span>
                            <menu-item-text menu-key="communication.my_meeting"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleMenu && showMenu('frontend') && hasPermission('configure-frontend')" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-13'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-13')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--teal"><admin-icon name="globe"></admin-icon></span>
                <menu-item-text menu-key="frontend.frontend"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-13'] }" id="collapse-13">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li v-if="showMenu('frontend_page')" class="nk-menu-item">
                        <router-link to="/frontend/page" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="file"></admin-icon></span>
                            <menu-item-text menu-key="frontend.page"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="showMenu('frontend_block')" class="nk-menu-item">
                        <router-link to="/frontend/block" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="layers"></admin-icon></span>
                            <menu-item-text menu-key="frontend.block"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="showMenu('frontend_menu')" class="nk-menu-item">
                        <router-link to="/frontend/menu" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="menu"></admin-icon></span>
                            <menu-item-text menu-key="frontend.menu"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="showMenu('frontend_menu')" class="nk-menu-item">
                        <router-link to="/frontend/slider" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="image"></admin-icon></span>
                            <menu-item-text menu-key="frontend.slider_image"></menu-item-text>
                        </router-link>
                    </li>
                    <li v-if="showMenu('frontend_menu')" class="nk-menu-item">
                        <router-link to="/frontend/news" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="megaphone"></admin-icon></span>
                            <menu-item-text menu-key="frontend.news_ticker"></menu-item-text>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>
        <li v-show="moduleMenu && showMenu('utility') && hasAnyPermission(['access-todo', 'access-configuration'])" class="nk-menu-item">
            <a href="#" class="nk-menu-link" :aria-expanded="mainAccordionOpen['collapse-14'] ? 'true' : 'false'" @click.prevent="toggleMain('collapse-14')" style="cursor: pointer;">
                <span class="nk-menu-icon nk-menu-icon--slate"><admin-icon name="wrench"></admin-icon></span>
                <menu-item-text menu-key="utility.utility"></menu-item-text>
                <admin-icon name="chevron" class="admin-nav-chevron"></admin-icon>
            </a>
            <div class="nk-menu-collapse" :class="{ 'is-open': mainAccordionOpen['collapse-14'] }" id="collapse-14">
                <ul class="nk-menu-sub sip-menu-sub">
                    <li v-if="hasPermission('access-todo') && showMenu('todo')" class="nk-menu-item">
                        <router-link to="/utility/todo" class="nk-menu-link">
                            <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="check-circle"></admin-icon></span>
                            <menu-item-text menu-key="utility.todo"></menu-item-text>
                        </router-link>
                    </li>

                    <template v-if="hasPermission('access-configuration')">
                        <!-- <li v-if="showMenu('backup')"><router-link to="/utility/backup">{{trans('utility.backup')}}</router-link></li> -->
                        <li v-if="showMenu('ip_filter')" class="nk-menu-item">
                            <router-link to="/utility/ip-filter" class="nk-menu-link">
                                <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="shield"></admin-icon></span>
                                <menu-item-text menu-key="utility.ip_filter"></menu-item-text>
                            </router-link>
                        </li>
                        <li class="nk-menu-item">
                            <router-link class="nk-menu-link" to="/utility/activity-log">
                                <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="clock"></admin-icon></span>
                                <menu-item-text menu-key="utility.activity_log"></menu-item-text>
                            </router-link>
                        </li>
                        <li v-if="featureAvailable('email_template')" class="nk-menu-item">
                            <router-link class="nk-menu-link" to="/utility/email-template">
                                <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="mail"></admin-icon></span>
                                <menu-item-text menu-key="utility.email_template"></menu-item-text>
                            </router-link>
                        </li>
                        <li v-if="featureAvailable('email_log')" class="nk-menu-item">
                            <router-link class="nk-menu-link" to="/utility/email-log">
                                <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="inbox"></admin-icon></span>
                                <menu-item-text menu-key="utility.email_log"></menu-item-text>
                            </router-link>
                        </li>
                        <li class="nk-menu-item">
                            <router-link class="nk-menu-link" to="/utility/scheduled-job">
                                <span class="nk-menu-icon nk-menu-icon-sub"><admin-icon name="hourglass"></admin-icon></span>
                                <menu-item-text menu-key="utility.scheduled_job"></menu-item-text>
                            </router-link>
                        </li>
                    </template>
                </ul>
            </div>
        </li>
        <li class="nk-menu-heading" v-show="moduleMenu && hasPermission('access-configuration')">
            <h6 class="overline-title">INSTITUTION CONFIG</h6>
        </li>
        <li v-show="moduleMenu && hasPermission('access-configuration')" class="nk-menu-item">
            <router-link to="/configuration" exact class="nk-menu-link">
                <span class="nk-menu-icon nk-menu-icon--slate"><admin-icon name="settings"></admin-icon></span>
                <menu-item-text menu-key="configuration.configuration"></menu-item-text>
            </router-link>
        </li>
        <li class="nk-menu-item">
            <router-link to="/change/password" exact class="nk-menu-link">
                <span class="nk-menu-icon nk-menu-icon--amber"><admin-icon name="lock"></admin-icon></span>
                <menu-item-text menu-key="user.change_password"></menu-item-text>
            </router-link>
        </li>
        <li class="nk-menu-item">
            <a href="#" exact class="nk-menu-link" @click.prevent="logout">
                <span class="nk-menu-icon nk-menu-icon--red"><admin-icon name="logout"></admin-icon></span>
                <menu-item-text menu-key="auth.logout"></menu-item-text>
            </a>
        </li>
    </ul>
</template>

<script>
import MenuItemText from './menu-item-text'
/**
 * Sidebar active matching: exact path, or segment-boundary prefix
 * (`route === to` OR `route.startsWith(to + '/')`), with longest menu
 * destination winning. Stops Vue Router's string prefix from marking
 * Subject active on Subject Teacher (`/academic/subject` vs
 * `/academic/subject/teacher`), and the same class of siblings
 * (Report vs Report Analysis, Certificate-style pairs, etc.).
 */
const MENU_LINK_PATHS = [
    '/academic/batch', '/academic/certificate', '/academic/class/teacher', '/academic/class/timing',
    '/academic/course', '/academic/session', '/academic/subject', '/academic/subject/teacher',
    '/academic/teacher/timetable', '/academic/timetable', '/behaviour/assign', '/behaviour/incidents',
    '/behaviour/reports', '/calendar/celebration/birthday', '/calendar/event', '/calendar/holiday',
    '/change/password', '/communication', '/communication/balance', '/communication/email',
    '/communication/meeting', '/communication/my-meeting', '/communication/notification', '/communication/push-notification',
    '/communication/sms', '/communication/whatsapp', '/configuration', '/configuration/academic/certificate/template',
    '/configuration/academic/course/group', '/configuration/academic/id-card/template', '/configuration/academic/institute', '/configuration/academic/marksheet/template',
    '/configuration/academic/print/template', '/configuration/asset/building', '/configuration/asset/room', '/configuration/authentication',
    '/configuration/basic', '/configuration/calendar/celebration-template', '/configuration/calendar/event/type', '/configuration/custom-field',
    '/configuration/employee', '/configuration/employee/attendance/type', '/configuration/employee/category', '/configuration/employee/department',
    '/configuration/employee/designation', '/configuration/employee/document/type', '/configuration/employee/group', '/configuration/employee/leave/type',
    '/configuration/employee/pay/head', '/configuration/exam/assessment', '/configuration/exam/authority', '/configuration/exam/grade',
    '/configuration/exam/marksheet/template', '/configuration/exam/observation', '/configuration/exam/remark-rule', '/configuration/exam/result-division-rule',
    '/configuration/exam/term', '/configuration/finance/payment/method', '/configuration/finance/transaction/category', '/configuration/frontend/index',
    '/configuration/hostel/category', '/configuration/library', '/configuration/library/book/author', '/configuration/library/book/condition',
    '/configuration/library/book/language', '/configuration/library/book/publisher', '/configuration/library/book/topic', '/configuration/locale',
    '/configuration/mail', '/configuration/menu', '/configuration/message_template', '/configuration/misc/blood/group',
    '/configuration/misc/caste', '/configuration/misc/category', '/configuration/misc/disability/type', '/configuration/misc/medium/instruction',
    '/configuration/misc/religion', '/configuration/module', '/configuration/payment/gateway', '/configuration/permission',
    '/configuration/post/article/type', '/configuration/reception/calling/purpose', '/configuration/reception/complaint/type', '/configuration/reception/enquiry/source',
    '/configuration/reception/enquiry/type', '/configuration/reception/visiting/purpose', '/configuration/role', '/configuration/sms',
    '/configuration/social', '/configuration/student', '/configuration/student/document/type', '/configuration/student/favorites',
    '/configuration/student/group', '/configuration/student/house', '/configuration/student/question', '/configuration/system',
    '/configuration/transport/vehicle/document/type', '/configuration/transport/vehicle/fuel/type', '/configuration/transport/vehicle/service/center', '/configuration/whatsapp',
    '/download-center/content-list', '/download-center/content-type', '/download-center/document-share-list', '/download-center/video-tutorial',
    '/employee/attendance', '/employee/card-view', '/employee/id-card', '/employee/import',
    '/employee/leave', '/employee/payroll', '/exam/record', '/exam/report',
    '/exam/report-card-attendance', '/exam/report/analysis', '/exam/report/analysis/export', '/exam/report/topper',
    '/exam/result-announcement', '/exam/schedule', '/finance/account', '/finance/fee/allocation',
    '/finance/fee/concession', '/finance/fee/group', '/finance/fee/head', '/finance/report',
    '/finance/transaction/account/transfer', '/finance/transaction/expense', '/finance/transaction/income', '/frontend/block',
    '/frontend/menu', '/frontend/news', '/frontend/page', '/frontend/slider',
    '/hostel/facilities', '/hostel/food-menu', '/hostel/hostel', '/hostel/incharge',
    '/hostel/meal-plan', '/hostel/meal-schedule', '/hostel/report', '/hostel/rooms',
    '/institute/document', '/inventory/stock/category', '/inventory/stock/item', '/inventory/stock/purchase',
    '/inventory/stock/transfer', '/inventory/vendor', '/lesson-plan/lessons', '/lesson-plan/manage-lesson-plan',
    '/lesson-plan/reports/status-report', '/lesson-plan/reports/subject-wise', '/lesson-plan/syllabus-status', '/lesson-plan/topics',
    '/library/book', '/library/issue', '/library/return', '/meet/live-class',
    '/meet/live-class/report', '/meet/live-meeting', '/meet/live-meeting/report', '/online-exam',
    '/post/article', '/post/feed', '/qr/attendance', '/qr/attendance-report',
    '/reception/call/log', '/reception/complaint', '/reception/enquiry', '/reception/gate/pass',
    '/reception/postal/record', '/reception/visitor/log', '/reception/visitor/message', '/reports/index',
    '/resource/assignment', '/resource/home-work', '/resource/lesson/plan', '/resource/notes',
    '/resource/syllabus', '/student/attendance', '/student/card-view', '/student/class-monitor',
    '/student/counsellor-report', '/student/id-card', '/student/image', '/student/import',
    '/student/login', '/student/parent', '/student/promotion', '/student/qr-code',
    '/student/roll/number', '/student/termination', '/transport/circle', '/transport/fee',
    '/transport/report', '/transport/route', '/transport/stoppage', '/transport/vehicle',
    '/transport/vehicle/document', '/transport/vehicle/fuel', '/transport/vehicle/incharge', '/transport/vehicle/log',
    '/transport/vehicle/service/record', '/utility/activity-log', '/utility/backup', '/utility/email-log',
    '/utility/email-template', '/utility/ip-filter', '/utility/scheduled-job', '/utility/todo'
];

function normalizeMenuPath(path) {
    if (!path || typeof path !== 'string') {
        return '';
    }
    var p = path.split('?')[0];
    if (p.length > 1 && p.charAt(p.length - 1) === '/') {
        p = p.slice(0, -1);
    }
    return p;
}

function menuLinkToPath(to) {
    if (to == null) {
        return '';
    }
    if (typeof to === 'string') {
        return normalizeMenuPath(to);
    }
    if (typeof to === 'object' && to.path) {
        return normalizeMenuPath(to.path);
    }
    return '';
}

function menuPathMatches(routePath, itemTo) {
    var path = normalizeMenuPath(routePath);
    var to = normalizeMenuPath(itemTo);
    if (!path || !to) {
        return false;
    }
    return path === to || path.indexOf(to + '/') === 0;
}

function menuQueryIncludes(currentQuery, targetQuery) {
    if (!targetQuery) {
        return true;
    }
    var cur = currentQuery || {};
    for (var key in targetQuery) {
        if (!Object.prototype.hasOwnProperty.call(targetQuery, key)) {
            continue;
        }
        var cv = cur[key] == null ? '' : String(cur[key]);
        var tv = targetQuery[key] == null ? '' : String(targetQuery[key]);
        if (cv !== tv) {
            return false;
        }
    }
    return true;
}

function isMenuLinkActiveForRoute(routePath, routeQuery, to, exact) {
    var itemTo = menuLinkToPath(to);
    var path = normalizeMenuPath(routePath);
    var itemQuery = (to && typeof to === 'object') ? to.query : null;
    if (exact) {
        return path === itemTo && menuQueryIncludes(routeQuery, itemQuery);
    }
    if (!menuPathMatches(path, itemTo)) {
        return false;
    }
    for (var i = 0; i < MENU_LINK_PATHS.length; i++) {
        var other = MENU_LINK_PATHS[i];
        if (!other || other === itemTo || other.length <= itemTo.length) {
            continue;
        }
        if (menuPathMatches(path, other)) {
            return false;
        }
    }
    return menuQueryIncludes(routeQuery, itemQuery);
}

function guardMenuLinkEvent(e) {
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) {
        return false;
    }
    if (e.defaultPrevented) {
        return false;
    }
    if (e.button !== undefined && e.button !== 0) {
        return false;
    }
    if (e.currentTarget && e.currentTarget.getAttribute) {
        var target = e.currentTarget.getAttribute('target');
        if (target && /\b_blank\b/i.test(target)) {
            return false;
        }
    }
    if (e.preventDefault) {
        e.preventDefault();
    }
    return true;
}

const MenuRouterLink = {
    name: 'RouterLink',
    props: {
        to: { type: [String, Object], required: true },
        exact: Boolean,
        replace: Boolean,
        append: Boolean,
    },
    computed: {
        resolvedHref() {
            return this.$router.resolve(this.to, this.$route, this.append).href;
        },
        isActive() {
            return isMenuLinkActiveForRoute(this.$route.path, this.$route.query, this.to, this.exact);
        },
        isExactActive() {
            return normalizeMenuPath(this.$route.path) === menuLinkToPath(this.to)
                && menuQueryIncludes(this.$route.query, (this.to && typeof this.to === 'object') ? this.to.query : null);
        },
    },
    methods: {
        navigate(e) {
            if (!guardMenuLinkEvent(e)) {
                return;
            }
            if (this.replace) {
                this.$router.replace(this.to);
            } else {
                this.$router.push(this.to);
            }
        },
    },
    render(h) {
        return h('a', {
            class: {
                'router-link-active': this.isActive,
                'router-link-exact-active': this.isExactActive,
                'is-active': this.isActive,
            },
            attrs: {
                href: this.resolvedHref,
                'aria-current': this.isExactActive ? 'page' : null,
            },
            on: { click: this.navigate },
        }, this.$slots.default);
    },
};

/** Top-level sidebar sections (accordion: only one open). Keys must match template ids. */
const MAIN_MENU_ACCORDION_IDS = [
    'collapse-1', 'collapse-2', 'collapse-3', 'collapse-100', 'collapse-101', 'collapse-102', 'collapse-103',
    'collapse-104', 'collapse-105', 'collapse-106', 'collapse-906', 'collapse-107', 'collapse-108', 'collapse-109',
    'collapse-110', 'collapse-111', 'collapse-112', 'collapse-4', 'collapse-zoom', 'collapse-lessons',
    'collapse-incidents', 'collapse-download-center', 'collapse-qr', 'collapse-5', 'collapse-6', 'collapse-26',
    'collapse-56', 'collapse-7', 'collapse-8', 'collapse-9', 'collapse-10', 'collapse-11', 'collapse-12',
    'collapse-13', 'collapse-14',
];

function buildMainAccordionOpen() {
    const o = {};
    MAIN_MENU_ACCORDION_IDS.forEach((id) => {
        o[id] = false;
    });
    return o;
}

/** Nested "… configuration" blocks inside main module menu (collapse-1, collapse-2, …). */
const NESTED_MODULE_MENU_CONFIG_KEYS = [
    'ReceptionConfig',
    'academic_config',
    'student_config',
    'employee_config',
    'examReportAnalysis',
    'exam_config',
    'finance_cofig',
    'transport_config',
    'hostel_config',
    'library_config',
];

function buildNestedModuleMenuConfigOpen() {
    const o = {};
    NESTED_MODULE_MENU_CONFIG_KEYS.forEach((k) => {
        o[k] = false;
    });
    return o;
}

/** When meta.menu === 'module-configuration', sidebar uses collapse-100+ only. Otherwise /configuration/* lives under main module accordions (collapse-1, …). */
const MODULE_CONFIGURATION_COLLAPSE_RULES = [
    [/^\/configuration\/reception\b/, 'collapse-100'],
    [/^\/configuration\/academic\b/, 'collapse-101'],
    [/^\/configuration\/finance\b/, 'collapse-102'],
    [/^\/configuration\/student\b/, 'collapse-103'],
    [/^\/configuration\/exam\b/, 'collapse-104'],
    [/^\/configuration\/employee\b/, 'collapse-105'],
    [/^\/configuration\/transport\b/, 'collapse-106'],
    [/^\/configuration\/hostel\b/, 'collapse-906'],
    [/^\/configuration\/library\b/, 'collapse-107'],
    [/^\/configuration\/calendar\b/, 'collapse-108'],
    [/^\/configuration\/post\b/, 'collapse-109'],
    [/^\/configuration\/asset\b/, 'collapse-110'],
    [/^\/configuration\/frontend\b/, 'collapse-111'],
    [/^\/configuration\/misc\b/, 'collapse-112'],
];

/** /configuration/* URLs mapped to the top-level main sidebar accordion that contains the nested config links. */
const MAIN_MENU_CONFIGURATION_PARENT_RULES = [
    [/^\/configuration\/reception\b/, 'collapse-1'],
    [/^\/configuration\/academic\b/, 'collapse-2'],
    [/^\/configuration\/student\b/, 'collapse-3'],
    [/^\/configuration\/exam\b/, 'collapse-5'],
    [/^\/configuration\/employee\b/, 'collapse-4'],
    [/^\/configuration\/finance\b/, 'collapse-6'],
    [/^\/configuration\/transport\b/, 'collapse-26'],
    [/^\/configuration\/hostel\b/, 'collapse-56'],
    [/^\/configuration\/library\b/, 'collapse-9'],
    [/^\/configuration\/calendar\b/, 'collapse-7'],
    [/^\/configuration\/post\b/, 'collapse-11'],
    [/^\/configuration\/frontend\b/, 'collapse-13'],
    [/^\/configuration\/misc\b/, 'collapse-14'],
];

const MAIN_MENU_STANDARD_RULES = [
    [/^\/reception\b/, 'collapse-1'],
    [/^\/academic\b/, 'collapse-2'],
    [/^\/reports\b/, 'collapse-2'],
    [/^\/student\b/, 'collapse-3'],
    [/^\/employee\b/, 'collapse-4'],
    [/^\/meet\b/, 'collapse-zoom'],
    [/^\/lesson-plan\b/, 'collapse-lessons'],
    [/^\/behaviour\b/, 'collapse-incidents'],
    [/^\/download-center\b/, 'collapse-download-center'],
    [/^\/qr\b/, 'collapse-qr'],
    [/^\/online-exam\b/, 'collapse-5'],
    [/^\/exam\b/, 'collapse-5'],
    [/^\/finance\b/, 'collapse-6'],
    [/^\/transport\b/, 'collapse-26'],
    [/^\/hostel\b/, 'collapse-56'],
    [/^\/calendar\b/, 'collapse-7'],
    [/^\/resource\b/, 'collapse-8'],
    [/^\/library\b/, 'collapse-9'],
    [/^\/inventory\b/, 'collapse-10'],
    [/^\/post\b/, 'collapse-11'],
    [/^\/communication\b/, 'collapse-12'],
    [/^\/frontend\b/, 'collapse-13'],
    [/^\/utility\b/, 'collapse-14'],
];

export default {
    components: {
        MenuItemText,
        RouterLink: MenuRouterLink,
    },
    data() {
        return {
            mainAccordionOpen: buildMainAccordionOpen(),
            nestedModuleMenuConfigOpen: buildNestedModuleMenuConfigOpen(),
        };
    },
    mounted() {
        this.applyMainAccordionForRoute(this.$route.path);
    },
    watch: {
        '$route.path'(path) {
            this.applyMainAccordionForRoute(path);
        },
    },
    methods: {
        toggleMain(id) {
            const opening = !this.mainAccordionOpen[id];
            MAIN_MENU_ACCORDION_IDS.forEach((k) => {
                this.$set(this.mainAccordionOpen, k, opening && k === id);
            });
            if (!opening) {
                this.resetNestedModuleMenuConfig();
            }
        },
        toggleNested(key) {
            this.$set(this.nestedModuleMenuConfigOpen, key, !this.nestedModuleMenuConfigOpen[key]);
        },
        applyMainAccordionForRoute(path) {
            const menuMeta = this.$route.meta && this.$route.meta.menu;
            const id = this.mainCollapseIdForPath(path, menuMeta);
            this.$nextTick(() => {
                if (!id || !Object.prototype.hasOwnProperty.call(this.mainAccordionOpen, id)) {
                    MAIN_MENU_ACCORDION_IDS.forEach((k) => {
                        this.$set(this.mainAccordionOpen, k, false);
                    });
                    this.resetNestedModuleMenuConfig();
                    return;
                }
                MAIN_MENU_ACCORDION_IDS.forEach((k) => {
                    this.$set(this.mainAccordionOpen, k, k === id);
                });
                this.applyNestedModuleMenuConfigForRoute(path, menuMeta);
            });
        },
        resetNestedModuleMenuConfig() {
            NESTED_MODULE_MENU_CONFIG_KEYS.forEach((k) => {
                this.$set(this.nestedModuleMenuConfigOpen, k, false);
            });
        },
        applyNestedModuleMenuConfigForRoute(path, menuMeta) {
            this.resetNestedModuleMenuConfig();
            if (menuMeta === 'module-configuration') {
                return;
            }
            const p = (path || '').split('?')[0];
            const key = this.nestedModuleMenuConfigKeyForPath(p);
            if (key && Object.prototype.hasOwnProperty.call(this.nestedModuleMenuConfigOpen, key)) {
                this.$set(this.nestedModuleMenuConfigOpen, key, true);
            }
        },
        nestedModuleMenuConfigKeyForPath(p) {
            if (!p) {
                return null;
            }
            if (/^\/configuration\/reception\b/.test(p)) {
                return 'ReceptionConfig';
            }
            if (/^\/configuration\/academic\b/.test(p)) {
                return 'academic_config';
            }
            if (/^\/configuration\/student\b/.test(p)) {
                return 'student_config';
            }
            if (/^\/configuration\/employee\b/.test(p)) {
                return 'employee_config';
            }
            if (/^\/configuration\/exam\b/.test(p)) {
                return 'exam_config';
            }
            if (/^\/configuration\/finance\b/.test(p)) {
                return 'finance_cofig';
            }
            if (/^\/configuration\/transport\b/.test(p)) {
                return 'transport_config';
            }
            if (/^\/configuration\/hostel\b/.test(p)) {
                return 'hostel_config';
            }
            if (/^\/configuration\/library\b/.test(p)) {
                return 'library_config';
            }
            if (/^\/exam\/report\/analysis\b/.test(p)) {
                return 'examReportAnalysis';
            }
            return null;
        },
        mainCollapseIdForPath(path, menuMeta) {
            if (!path || typeof path !== 'string') {
                return null;
            }
            const p = path.split('?')[0];
            const useModuleConfigSidebar = menuMeta === 'module-configuration';

            if (useModuleConfigSidebar) {
                for (let i = 0; i < MODULE_CONFIGURATION_COLLAPSE_RULES.length; i++) {
                    const re = MODULE_CONFIGURATION_COLLAPSE_RULES[i][0];
                    const cid = MODULE_CONFIGURATION_COLLAPSE_RULES[i][1];
                    if (re.test(p)) {
                        return cid;
                    }
                }
            } else {
                for (let i = 0; i < MAIN_MENU_CONFIGURATION_PARENT_RULES.length; i++) {
                    const re = MAIN_MENU_CONFIGURATION_PARENT_RULES[i][0];
                    const cid = MAIN_MENU_CONFIGURATION_PARENT_RULES[i][1];
                    if (re.test(p)) {
                        return cid;
                    }
                }
                for (let i = 0; i < MAIN_MENU_STANDARD_RULES.length; i++) {
                    const re = MAIN_MENU_STANDARD_RULES[i][0];
                    const cid = MAIN_MENU_STANDARD_RULES[i][1];
                    if (re.test(p)) {
                        return cid;
                    }
                }
            }
            return null;
        },
        isMenuLinkActive(to, exact) {
            return isMenuLinkActiveForRoute(this.$route.path, this.$route.query, to, !!exact);
        },
        hasPermission(permission) {
            return helper.hasPermission(permission);
        },
        hasAnyPermission(permissions) {
            return helper.hasAnyPermission(permissions);
        },
        hasRole(role) {
            return helper.hasRole(role);
        },
        hasNotAnyRole(role) {
            return helper.hasNotAnyRole(role);
        },
        getConfig(config) {
            return helper.getConfig(config);
        },
        featureAvailable(feature) {
            return helper.featureAvailable(feature);
        },
        showMenu(menu) {
            let menus = helper.getConfig('menu');
            return (Array.isArray(menus) && menus.findIndex(o => o === menu) >= 0) ? true : false;
        },
        logout(){
            helper.logout().then(() => {
                this.$router.push('/login')
            })
        },
    },
    computed: {
        configMenu() {
            return this.$route.meta.menu == 'configuration' ? true : false;
        },
        moduleConfigMenu() {
            return this.$route.meta.menu == 'module-configuration' ? true : false;
        },
        moduleMenu() {
            return this.$route.meta.menu != 'configuration' && this.$route.meta.menu != 'module-configuration' ? true : false;
        },
        hasExamReportAnalysis() {
            let academic_session = helper.getDefaultAcademicSession();
            return academic_session && academic_session.exam_report_analysis ? true : false
        }
    }
}
</script>